import type { GetAssessmentActivityByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentActivityByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetAssessmentActivityByIdArgs = {
  id: string;
};

export const useGetAssessmentActivityById = createQueryHook<
  UseGetAssessmentActivityByIdArgs,
  GetAssessmentActivityByIdQuery,
  GetAssessmentActivityByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.assessment.activityById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => data,
  graphqlDocument: GetAssessmentActivityByIdDocument,
  graphqlVariables: ({ id }) => ({ AssessmentActivityId: id }),
});
